import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Button,
  TextField,
} from "@mui/material";

const ChangePercentageDialog = ({
  open,
  onClose,
  headerName,
  filterData,
  handleChange,
  handleChangePercentage,
  isOverAllocation,
  isSubmitting,
  userList,
  totalCaseCaseCapacity,
}) => {
  // Calculate old percentage for this advisor
  let oldPercentage = 0;
  if (open && headerName && userList.length > 0) {
    const found = userList.find((u) => u.name === headerName);
    if (found && found.percentage_allocation) {
      oldPercentage = parseInt(found.percentage_allocation) || 0;
    }
  }
  const currentValue = parseInt(filterData.percentage) || 0;
  const newTotal = totalCaseCaseCapacity - oldPercentage + currentValue;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: 6,
          backgroundColor: "#fdfdfd",
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: "#000",
          color: "#fff",
          fontWeight: "bold",
          fontSize: "18px",
          py: 2,
          px: 3,
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
        }}
      >
        Change Percentage
        <span style={{ fontSize: "16px", marginLeft: "4px" }}>
          ({headerName})
        </span>
      </DialogTitle>
      <DialogContent sx={{ px: 3, py: 2 }}>
        <Box
          sx={{
            color: "#333",
            fontSize: 15,
            lineHeight: 1.7,
            backgroundColor: "#fffefb",
            p: 2,
            borderRadius: 2,
          }}
        >
          <div className="mb-3"></div>
          <div className="col-12 col-12 mt-3">
            <TextField
              id="outlined-basic"
              label="Change percentage %"
              variant="outlined"
              required
              fullWidth
              type="number"
              name="percentage"
              value={filterData.percentage}
              placeholder="Change percentage 1 to 100%"
              onChange={(e) => {
                const value = parseInt(e.target.value, 10);
                if (value >= 1 && value <= 100) {
                  handleChange(e);
                } else if (!e.target.value) {
                  handleChange(e);
                }
              }}
              onKeyDown={(e) => {
                if (
                  e.key === "0" &&
                  (!e.target.value || e.target.value === "0")
                ) {
                  e.preventDefault();
                }
              }}
              inputProps={{ min: 1, max: 100 }}
            />
            {/* Allocation info/warning message below input, left-aligned, above buttons */}
            {(() => {
              // Show warning if total goes over 100%
              if (newTotal > 100) {
                const over = newTotal - 100;
                return (
                  <div
                    style={{
                      backgroundColor: "#ffebee",
                      color: "#c62828",
                      padding: "8px 12px",
                      borderRadius: "4px",
                      marginTop: "8px",
                      fontSize: "14px",
                      border: "1px solid #ef5350",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: 8,
                    }}
                  >
                    <span
                      style={{
                        marginRight: 8,
                        fontWeight: "bold",
                        fontSize: 18,
                      }}
                    >
                      ❌
                    </span>
                    <span>
                      You are over by {over}%. Reduce allocations to stay within
                      100%.
                    </span>
                  </div>
                );
              }
              // Show info message if within limits
              if (
                filterData.percentage !== "" &&
                filterData.percentage !== undefined &&
                filterData.percentage !== null
              ) {
                const remaining = Math.max(0, 100 - newTotal);
                return (
                  <div
                    style={{
                      backgroundColor: "#fffae5",
                      color: "warning",
                      padding: "8px 12px",
                      borderRadius: "4px",
                      marginTop: "8px",
                      fontSize: "14px",
                      border: "1px solid gold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: 8,
                    }}
                  >
                    <span
                      style={{
                        marginRight: 8,
                        fontWeight: "bold",
                        fontSize: 18,
                      }}
                    >
                      ⚠️
                    </span>
                    <span>
                      You have {remaining}% left to allocate to reach 100%.
                    </span>
                  </div>
                );
              }
              // Show initial info message when dialog opens
              if (open) {
                const left = Math.max(0, 100 - totalCaseCaseCapacity);
                return (
                  <div
                    style={{
                      backgroundColor: "#fffae5",
                      padding: "8px 12px",
                      borderRadius: "4px",
                      marginTop: "8px",
                      fontSize: "14px",
                      border: "1px solid gold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: 8,
                    }}
                  >
                    <span
                      style={{
                        marginRight: 8,
                        fontWeight: "bold",
                        fontSize: 18,
                      }}
                    >
                      ⚠️
                    </span>
                    <span>
                      You have {left}% left to allocate to reach 100%.
                    </span>
                  </div>
                );
              }
              return null;
            })()}
          </div>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: "#000",
            "&:hover": { backgroundColor: "#000" },
            color: "#fff",
            textTransform: "none",
            px: 3,
            borderRadius: 2,
          }}
        >
          Close
        </Button>
        <Button
          onClick={handleChangePercentage}
          variant="contained"
          disabled={isOverAllocation}
          sx={{
            backgroundColor: "#000",
            "&:hover": { backgroundColor: "#000" },
            color: "#fff",
            textTransform: "none",
            px: 3,
            borderRadius: 2,
          }}
        >
          {isSubmitting ? "Changing..." : "Change Percentage"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePercentageDialog;
